import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import SideBar from "./SideBar";

/**
 * Wrapper de mise en page partagé par toutes les pages de l'application.
 *
 * Usage minimal :
 *   <PageLayout currentMenu="PRODUCTION">
 *     <div>contenu</div>
 *   </PageLayout>
 *
 * Avec NavBar enrichie (recherche, etc.) :
 *   <PageLayout currentMenu="PRODUCTION" navBarProps={{ filteredResults, setFilteredResults }}>
 *     ...
 *   </PageLayout>
 *
 * Sans padding intérieur (page full-width) :
 *   <PageLayout currentMenu="SINISTRES" noPadding>
 *     ...
 *   </PageLayout>
 */
const PageLayout = ({
    children,
    currentMenu = "DASHBOARD",
    navBarProps = {},
    noPadding = false,
}) => (
    <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
            <SideBar currentMenu={currentMenu} />
            <div className="layout-page">
                <NavBar {...navBarProps} />
                <div className="content-wrapper">
                    <div className={noPadding ? "" : "container-xxl flex-grow-1 container-p-y"}>
                        {children}
                    </div>
                    <Footer />
                    <div className="content-backdrop fade"></div>
                </div>
            </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
    </div>
);

export default PageLayout;
